'use client';
import { getDefaultZIndex } from '@s7/styles';

const IDENT = 'Popover';
const defaultMiddlewares = {
    flip: true,
    shift: true,
    inline: false
};
const defaultProps = {
    position: 'bottom',
    shadow: 'z500',
    radius: '1.5r',
    offset: 8,
    positionDependencies: [],
    middlewares: defaultMiddlewares,
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: 'side',
    closeOnClickOutside: true,
    withinPortal: false,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    clickOutsideEvents: [
        'mousedown',
        'touchstart'
    ],
    zIndex: getDefaultZIndex('popover'),
    width: 'max-content'
};

export { IDENT, defaultMiddlewares, defaultProps };
//# sourceMappingURL=Popover.contract.js.map
